import * as api from '../_api';

export const read = async ({ commit, dispatch }, { hostId, eventId }) => {
  try {
    const result = await api.read(eventId, hostId);
    commit('setEvent', result.event);
    commit('setHost', result.host);
    commit('setSavedGuests', result.savedGuests);
    commit('setEventGuests', result.eventGuests);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const removeGuest = async ({ commit, dispatch }, { eventId, hostId, guestId }) => {
  try {
    await api.removeGuest(eventId, hostId, guestId);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const addGuests = async ({ commit, dispatch }, { eventId, hostId, guests }) => {
  try {
    await api.addGuests(eventId, hostId, guests);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const createGuest = async ({ commit, dispatch }, { hostId, eventId, guest }) => {
  try {
    await api.createGuest(eventId, hostId, guest);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};
